export default {
  methods: {
    async templateRequest(action, data, onSuccess, onFail) {
      if (!action) return;

      try {
        await this.$store.dispatch(action, data);

        if (onSuccess) {
          if (onSuccess()) {
            return;
          }
        }

        this.$notify({
          type: "success",
          group: "foo",
          text: "Hello user! This is a notification!"
        });
      } catch (_) {
        if (onFail) {
          if (onFail()) {
            return;
          }
        }

        this.$notify({
          type: "error",
          group: "foo",
          text: "Hello user! This is a notification!"
        });
      }
    }
  }
};
